var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192.8 192.8",
    style: {
      enableBackground: "new 0 0 192.8 192.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,147.8c0.3-2.8,0.4-6.4,0.4-9.3c0-46.5-37.7-84.3-84.3-84.3C49.8,54.2,12,91.9,12,138.5 c0,3.2,0.2,6.3,0.5,9.3H3.2c-0.3-3.1-0.5-6.1-0.5-9.3C2.7,86.8,44.6,45,96.2,45c51.7,0,93.5,41.9,93.5,93.5c0,3.1-0.2,6.3-0.5,9.3 H180.2L180.2,147.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.2,145.7 52.1,135.5 52.1,147.9 65.7,147.9 65.7,120.3 52.1,120.3 42.2,132.1 32.4,120.3  18.7,120.3 18.7,147.9 32.4,147.9 32.4,135.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "126.6,120.3 126.6,147.9 140.2,147.9 140.2,133.4 158.4,147.9 172.9,147.9 172.9,120.3 159.2,120.3  159.2,135.1 140.2,120.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.8,147.9 88.2,120.3 104.1,120.3 121.7,147.9 107.2,147.9 96.2,130.5 90.8,139.3 101.6,139.3  105.6,145.4 86.9,145.4 85.2,147.9  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.4f0a3d34cc8315727a78fca701bf1af0.svg";
export { ForwardRef as ReactComponent };